import type { Appearance } from '@stripe/stripe-js'

import { cssVariableToHex } from '~/utils/css-variable-to-hex'
import { extractCssVariableValue } from '~/utils/extract-css-variable-value'
import { getIsDarkMode } from '~/utils/get-is-dark-mode'

const lightColorFallbacks = {
  background: '#ffffff',
  destructive: '#ef4444',
  foreground: '#020817',
  input: '#e2e8f0',
  mutedForeground: '#64748b',
  primary: '#0f172a',
} as const

const darkColorFallbacks = {
  background: '#020817',
  destructive: '#7f1d1d',
  foreground: '#f8fafc',
  input: '#1e293b',
  mutedForeground: '#94a3b8',
  primary: '#f8fafc',
} as const

const colorFromVariable = (variableName: string, fallbackHex: string) => cssVariableToHex(variableName) ?? fallbackHex

export const getStripeElementsAppearance = (isDarkMode = getIsDarkMode()): Appearance => {
  const colorFallbacks = isDarkMode ? darkColorFallbacks : lightColorFallbacks

  return {
    theme: isDarkMode ? 'night' : 'stripe',
    variables: {
      borderRadius: extractCssVariableValue('--radius').trim() || '0.5rem',
      colorBackground: colorFromVariable('--background', colorFallbacks.background),
      colorDanger: colorFromVariable('--destructive', colorFallbacks.destructive),
      colorPrimary: colorFromVariable('--primary', colorFallbacks.primary),
      colorText: colorFromVariable('--foreground', colorFallbacks.foreground),
      colorTextSecondary: colorFromVariable('--muted-foreground', colorFallbacks.mutedForeground),
      fontFamily: 'Inter Variable, ui-sans-serif, system-ui, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',
    },
    rules: {
      '.Input': {
        borderColor: colorFromVariable('--input', colorFallbacks.input),
      },
      '.Label': {
        color: colorFromVariable('--foreground', colorFallbacks.foreground),
      },
    },
  }
}
